import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const createSubject = async (data) => {
  const res = await axiosInstance.post("/subjects/create", data);
  return res.data;
};

export const getAllSubjects = async (filters = {}) => {
  const res = await axiosInstance.get("/subjects/all", { params: filters });
  return res.data;
};

export const getSubjectById = async (id) => {
  const res = await axiosInstance.get(`/subjects/${id}`);
  return res.data;
};

export const updateSubject = async (id, data) => {
  const res = await axiosInstance.put(`/subjects/update/${id}`, data);
  return res.data;
};

export const deleteSubject = async (id) => {
  const res = await axiosInstance.delete(`/subjects/delete/${id}`);
  return res.data;
};